/**
 * BusinessIdeasSlugRouter — /business-ideas/:seg1[/:seg2]
 *
 * The existing router had `/business-ideas/:industry` and
 * `/business-ideas/:industry/:ventureType`. R109.12 also wants
 * `/business-ideas/under-5-lakh` and `/business-ideas/under-10-lakh/ludhiana`
 * on the same path shape. This tiny dispatcher decides which page to
 * render based on the first segment.
 */
import { useParams } from "react-router-dom";
import { IndustryLanding, VentureTypeLanding } from "@/pages/SeoLanding";
import SeoComboLanding from "@/pages/SeoComboLanding";
import CategoryCityLanding from "@/pages/CategoryCityLanding";

const BUDGET_BANDS = new Set([
  "under-1-lakh",   "under-2-lakh",   "under-3-lakh", "under-5-lakh",
  "under-10-lakh",  "under-15-lakh",  "under-20-lakh",
  "under-25-lakh",  "under-50-lakh",  "under-1-crore",
  "above-50-lakh",  "above-1-crore",
]);

export function BusinessIdeasOneSeg() {
  const { seg1 } = useParams();
  // R202 — category×city programmatic matrix: <category>-franchise-in-<city>
  if ((seg1 || "").includes("-franchise-in-")) return <CategoryCityLanding />;
  if (BUDGET_BANDS.has(seg1)) return <SeoComboLanding />;
  // Fall back to industry landing (existing behaviour).
  return <IndustryLanding />;
}

export function BusinessIdeasTwoSeg() {
  const { seg1 } = useParams();
  if (BUDGET_BANDS.has(seg1)) return <SeoComboLanding />;
  return <VentureTypeLanding />;
}
